<!-- 营养养分控制 -->
<template>
  <a-modal
    :title="title"
    :visible="visible.nut"
    v-if="visible.nut"
    @cancel="cancel"
    :bodyStyle="modalBodyStyle"
    :destroyOnClose="true"
    :footer="false"
    width="1100px">
      <a-row type="flex" align="middle" justify="space-between" style="padding-bottom:10px;">
        <!-- <a-input-search :allowClear="true" size="small" v-model="keyword" placeholder="输入名称/代码" style="width:220px" @search="onSearch" /> -->
        <div>
          <a-input-search :allowClear="true" size="small" v-model="keyword" placeholder="输入名称/代码" style="width:180px;margin-right: 10px;" @search="e => onSearch(e,'keyword')" />
          <a-input-search v-if="overseasFlag == '1'" :allowClear="true" size="small" v-model="aliasName" style="width:180px" placeholder="请输入原料别名" @search="e => onSearch(e,'aliasName')"/>
        </div>
        <base-list-select style="width:220px" category="raw" placeholder="选择类型" @change="typeChange" v-model="types" />
      </a-row>
      <a-table
        :columns="columns"
        :data-source="list.records"
        :row-key="(record,index )=> index"
        :scroll="{ x:0, y: 360 }"
        :pagination="false"
        :loading="listLoading">
        <template slot="name" slot-scope="text,record">
          {{overseasFlag == '1' ? (record.aliasName || text) : text}}
        </template>

        <template
          slot="nutritionValue"
          slot-scope="text">
          {{text|numberFixed(4)}}
        </template>
        <template
          v-for="col in ['percentage','content']"
          :slot="col"
          slot-scope="text">
          {{text|numberFixed(3)}}
        </template>
        <template slot="contentPercentage"
          slot-scope="text">
            {{text * 100|numberFixed(3)}}
        </template>
    </a-table>
  </a-modal>
</template>

<script>
import { nhfMixins } from '../../untils'
import BaseListSelect from '../select/BaseListSelect.vue'

export default {
  components: { BaseListSelect },
  props:['hidden'],
  mixins:[nhfMixins],
  data(){
    return {
      columns:[
        {
          dataIndex:'name',
          title:'原料名称',
          width:200,
          scopedSlots: {customRender: 'name'},
        },
        {
          dataIndex:'code',
          title:'代码',
          width:95
        },
        {
          dataIndex:'typeName',
          title:'原料类型',
          width:150
        },
        {
          dataIndex:'percentage',
          title:'用量(%)',
          scopedSlots: {customRender: 'percentage'},
          sorter: (a, b) => a.percentage - b.percentage,
          sortDirections: ['descend', 'ascend'],
          align:'center',
          width:100
        },
        {
          dataIndex:'nutritionValue',
          scopedSlots: {customRender: 'nutritionValue'},
          sorter: (a, b) => a.nutritionValue - b.nutritionValue,
          sortDirections: ['descend', 'ascend'],
          title:'数值',
          align:'center',
          width:100
        },
        {
          dataIndex:'content',
          scopedSlots: {customRender: 'content'},
          sorter: (a, b) => a.content - b.content,
          sortDirections: ['descend', 'ascend'],
          title:'养分贡献值',
          align:'center',
          width:100
        },
        {
          dataIndex:'contentPercentage',
          scopedSlots: {customRender: 'contentPercentage'},
          sorter: (a, b) => a.contentPercentage - b.contentPercentage,
          sortDirections: ['descend', 'ascend'],
          title:'养分贡献值(%)',
          align:'center',
          width:100
        }
      ],
      keyword:'',
      aliasName: '',
      types:[],
      listLoading:false,
      equation:{
        records:[]
      },
      overseasFlag: window.localStorage.getItem('overseasFlag')
    }
  },
  mounted(){
    this.getEquationList()
  },
  watch:{
    'visible.nut'(val){
      if(val){
        const {nutritionId} = this.nutSelect
        this.getList({nutritionId})
      } else {
        this.types = []
        this.keyword = ''
        this.aliasName = ''
      }
    }
  },
  computed:{
    title(){
      return this.nutSelect ? this.nutSelect.nutritionName || '' : ""
    }
  },
  methods:{
    itemChange(value, id, column) {
      const newData = [...this.list.records]
      const target = newData.filter(item => id === item.id)[0]
      if (target) {
        target[column] = value
        this.list.records = newData
      }
    },

    eidtorItem(id){
      this.cacheData = [...this.list.records]
      const newData = [...this.list.records]
      const target = newData.filter(item => id === item.id)[0]
      this.editingKey = id
      if (target) {
        target.editable = true
        this.list.records = newData
      }
    },

    saveHandle(key){
      const newData = [...this.list.records]
      const newCacheData = [...this.cacheData]
      const target = newData.filter(item => key === item.id)[0]
      const targetCache = newCacheData.filter(item => key === item.id)[0]
      if (target && targetCache) {
        delete target.editable
        this.list.records = newData
        Object.assign(targetCache, target)
        this.cacheData = newCacheData
      }
    },
    cancel(){
      this.types = []
      this.keyword = ''
      this.aliasName = ''
      this.toggleVisible('nut')
    },
    cancelHandle(id){
      let newData = [...this.list.records]
      let target = newData.filter(item => id === item.id)[0]
      this.editingKey = ''
      console.log(target)
      if (target) {
        Object.assign(target, this.cacheData.filter(item => id === item.id)[0]);
        target.editable = false
        this.list.records = newData
      }
    },

    onSearch(val,field){
      this.getList({
        [field]: val
      })
    },

    typeChange(val = []){
      this.types = val
      console.log(val)
      if(val && val.length){
        const typeId = [...val].pop()
        this.getList({ typeId })
      } else {
        this.getList()
      }
    },

    getEquationList(){
      this.fetchGet({
          showMessage:false,
        actions:this.equationList,
        name:'equation',
        data:{
          size:200
        }
      })
    },

    async getList(arg= {}){
      const params = {
        nutritionId:this.nutSelect.nutritionId,
        formulaId:this.formulaId
      }
      if(this.types.length) params.typeId=[...this.types].pop()
      if(this.keyword) params.keyword = this.keyword
      if(this.aliasName) params.aliasName = this.aliasName
      await this.fetchPost({
        actions:this.selectFormulaNutritionToRawPage,
        isList:true,
        showMessage: false,
        loading:'listLoading',
        name:'list',
        data:{
          ...params,
          ...arg,
          factoryId:window.localStorage.getItem('factoryId'),
          current: 1,
          size:1200,
        },
      })
      // 手动排序
      this.sortData('content', 'descend')
    },
    sortData(column, order) {
      this.list.records.sort((a, b) => {
        if (order === 'ascend') {
          return a[column] - b[column];
        } else {
          return b[column] - a[column];
        }
      });
    }
  }
}
</script>
